import React, { Fragment, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { routes } from "./Routes";
import Layout from "../Layout/Layout";
import { useSelector } from "react-redux";
import { navbarSelector } from "../Auth/navbarSlice";
import PageNotFound from "../Pages/404";

const LayoutRoutes = () => {
  const url = window.location.pathname;
  const parts = url.split("/");
  const hotelCode = parts[1];
  const currentRoute = parts[2];

  const {
    profileData,
    navbarData,
    isLoading,
    status,
  } = useSelector(navbarSelector); // Don't remove this line

  const handleCheck = () => {
    const isRouteAvailable = routes.some(
      (val) => val.path.split('/')[1] === currentRoute,
    );
    return isRouteAvailable;
  };

  useEffect(() => {
    handleCheck();
  }, []);

  const checkRoutePermission = (path) => {
    const pagePermission = profileData?.department?.accessPages?.find(
      (page) => `/${page.name}` === path,
    );
    return pagePermission?.read;
  };

  const renderRoute = ({
    path,
    Component,
    hideLayout,
    i,
  }) => {
    if (hideLayout) {
      return <Route path={path} element={Component} key={i} />;
    }
    return (
      <Route element={<Layout />} key={i}>
        <Route path={path} element={Component} />
      </Route>
    );
  };

  // If hotel data is missing
  if (!navbarData?.success && !isLoading) {
    return (
      <h3 style={{ height: '88vh', display: 'grid', placeContent: 'center' }}>
        {'Data not found for the Hotel'}
      </h3>
    );
  }

  // If profile data is still loading or not available
  if (!profileData) {
    return null; // You can replace with a loader if needed
  }

  // Render routes
  return (
    <Fragment>
      <Routes>
        {routes.map(
          (
            {
              path,
              Component,
              hideLayout,
              userRoutes,
            },
            i,
          ) => {
            if (userRoutes || checkRoutePermission(path)) {
              return renderRoute({
                path,
                Component,
                hideLayout,
                userRoutes,
                i,
              });
            }

            return (
              <Route element={<Layout />} key={i}>
                <Route path={path} element={<PageNotFound />} />
              </Route>
            );
          },
        )}
      </Routes>
    </Fragment>
  );
};

export default LayoutRoutes;
